import React from "react";
// import DeviceContext from "../service/indentifyDevice";
import DeviceContext from "../../../services/indentifyDevice";

const Search = (props) => {
  const { setSearchVal, searchVal, searchFaqData, updateFaqBySearch } = props;

  function reset() {
    let isSearchForm = document.getElementById("mob_search_form");
    isSearchForm.style.display = "none";
    document.getElementById("support_mob_head").style.display = "flex";
    setSearchVal("");
  }

  return (
    <div className="search_form">
      <button className="i_search">
        <i className="edel-icon-search"></i>
      </button>
      <input
        id="tableDataSearchEle"
        autoFocus
        type="text"
        value={searchVal}
        onChange={(e) => setSearchVal(e.target.value)}
        placeholder="Search for keywords, phrases you are looking for"
        autoComplete="off"
      />

      {!DeviceContext().isDesktop && (
        <button className="i_close edBtn" onClick={() => reset()}>
          <span>
            <i className="edel-icon-close"></i>
          </span>
          close
        </button>
      )}

      {searchVal.length > 0 ? (
        <div className="search_modal">
          {searchFaqData && searchFaqData.qa ? (
            <ul>
              {searchFaqData.qa.map((qa, i) => {
                return (
                  <li key={i}>
                    <div className="faq_search_wrap">
                      <h4 onClick={() => updateFaqBySearch(qa)}>
                        {qa.question}
                      </h4>
                      <p>{qa.emtAnswer}</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <ul>
              <li>
                <div className="faq_search_wrap">
                  <h2>No Data Found</h2>
                </div>
              </li>
            </ul>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default Search;
